import { InjectionToken, Provider } from '@angular/core';

export interface CommunityNavigationConfig {
  /**
   * When true, post click navigates to user_homepage/post/?postId=...
   * instead of internal routing. Falls back to social link if available.
   */
  useExternalPostNavigation: boolean;
  /**
   * When true, shows user_logo in post header instead of platform icon
   * when user_logo is available.
   */
  showUserLogo: boolean;
}

const DEFAULT_CONFIG: CommunityNavigationConfig = {
  useExternalPostNavigation: false,
  showUserLogo: false,
};

export const COMMUNITY_NAVIGATION_CONFIG = new InjectionToken<CommunityNavigationConfig>(
  'COMMUNITY_NAVIGATION_CONFIG'
);

export function provideCommunityNavigationConfig(config: Partial<CommunityNavigationConfig> = {}): Provider[] {
  return [
    {
      provide: COMMUNITY_NAVIGATION_CONFIG,
      useValue: { ...DEFAULT_CONFIG, ...config },
    },
  ];
}
